<template>
  <div class="modal fade printable" id="fee-values" tabindex="-1" role="dialog"
      data-backdrop="static" aria-labelledby="exampleModalLongTitle" aria-hidden="true">
    <div class="modal-dialog history-modal" role="document">
      <div class="modal-content">
        <div class="modal-body row">
          <div class="col-6 offset-3">
            <table class="table table-striped table-sm table-bordered">
             <thead>
              <tr class="table-secondary">
                <th>Código</th>
                <th>Descripción</th>
                <th>Precio</th>
              </tr>
             </thead>
             <tbody>
             <tr v-if="loading">
              <td colspan="3">Cargando...</td>
             </tr>
             <tr v-for="fee of feeList" :key="fee.FeeCode">
              <td>{{fee.FeeCode}}</td>
              <td>{{fee.Name}}</td>
              <td>{{formatPrice(fee)}}</td>
             </tr>
            </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
            <button type="button" class="btn btn-secondary" @click="$emit('close')">Cerrar</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

export default {
  name: 'feevalues',
  data () {
    return {
      loading: false,
      fetchedFees: null,
    }
  },
  computed: {
    ...mapState({
      storeFees: state => state.fees,
    }),
    feeList () {
      let fees = this.fetchedFees || this.storeFees || [];
      return _.sortBy(
        _.filter(fees, (f) => !f.InActive && !f.Closed),
        'FeeCode'
      );
    }
  },
  async mounted () {
    if (this.storeFees && this.storeFees.length) return;
    this.loading = true;
    this.fetchedFees = await app.get('/api/fee/');
    this.loading = false;
  },
  methods: {
    formatPrice (fee) {
      let value = app.resolveFeeAmount(fee, {currency: 'ARS', marketType: 0});
      if (value === null || value === undefined || value === '') return '';
      let num = parseFloat(value);
      if (isNaN(num)) return '';
      return '$ ' + app.numberFormat(num);
    }
  }
}
</script>
